<template>
  <div class="w-100 mt-5">
    <ModalConfirm
      modalId="paidDetailModal"
      :text="`Are you sure to ${statusModal} this order?`"
      @onClick="handleModalConfirm" 
      :center="true"
    />
    <TemplateModal :show="showModalReason" @handleClose="showModalReason=false" :center="true">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title fsize-16 text-capitalize">Cancel Order</p>
        </div>
        <div class="modal-body pb-0">
          <div class="row mb-2">
            <label class="col-lg-12 ms-2 form-label fw-bold text-start">
              Enter cancel reason
            </label>
            <div class="col-lg-12">
              <textarea class="form-control m-2" rows="5" v-model="reason" style="width: 98%;"></textarea>
            </div>
          </div>
        </div>
        <div class="d-flex justify-content-center mb-3">
          <button type="button"
            class="btn btn-secondary bg-white border border-danger text-danger rounded ms-4 me-3 w-50"
            @click="showModalReason=false">Cancel</button>
          <button type="button" class="btn btn-danger text-white shadow-sm rounded w-50 me-4 text-uppercase"
            @click="changeStatus()">Confirm</button>
        </div>
      </div>
    </TemplateModal>

    <div class="d-flex">
      <div>
        <CardInfo title="Buyer" :cardData="dataSeller[0]" />
      </div>
      <div class="ms-4" v-if="dataSeller[5]">
        <CardInfo title="Receiver" :cardData="dataSeller[5]" />
      </div>
      <div class="ms-4">
        <CardInfo title="Seller" :cardData="dataSeller[1]" />
      </div>
      <div class="ms-4">
        <CardInfo title="Order Status" :cardData="dataSeller[2]" />
      </div>
      <div class="ms-4" v-if="dataSeller[3]">
        <CardInfo title="Reason" :cardData="dataSeller[3]" />
      </div>
      <div class="ms-4" v-if="dataSeller[4]">
        <CardInfo title="Dropshipper" :cardData="dataSeller[4]" />
      </div>
    </div>
    <div class="row">
      <div class="card text-start p-3 mx-2 mt-2 mb-5">
        <div class="d-flex">
          <div style="width: 60%">
            <div
              class="d-flex mb-3"
              v-for="data in dataSellerDetail"
              :key="data"
            >
              <div style="width: 100%">
                <div class="d-flex mb-3">
                  <div class="d-flex align-items-center" style="width: 60%">
                    <div
                      class="me-3 rounded"
                      style="
                        background-color: #e0e3ec;
                        justify-content: center;
                        align-self: center;
                        width: fit-content;
                      "
                    >
                      <img
                        class="rounded"
                        :src="filters.storeImageParse(data.seller_photo_url)"
                        style="height: min-content"
                        width="30"
                        alt=""
                      />
                    </div>
                    <div>
                      {{ data.seller_name }}
                      <br />
                      <font-awesome-icon
                        icon="fa-solid fa-location-dot"
                        class="pe-2 text-secondary"
                      />
                      <span class="fw-bold text-secondary">{{
                        data.seller_location
                      }}</span>
                    </div>
                  </div>
                  <div class="d-flex justify-content-end" style="width: 40%">
                    <span class="text-start fw-bold">
                      Child Order ID :
                      <br />
                      <span class="fw-bold text-primary">{{
                        data.child_order_id
                      }}</span>
                    </span>
                  </div>
                </div>
                <div class="product-list header">
                  <div class="list product">PRODUCT NAME</div>
                  <div class="list price">PRODUCT PRICE</div>
                  <div class="list qty">QTY</div>
                  <div class="list total">SUBTOTAL</div>
                </div>
                <div
                  class="product-list"
                  v-for="item in data.product_items"
                  :key="item.product_id"
                >
                  <div class="list product">
                    <Image
                      :src="filters.imageParse(item.display_image_url)"
                      :width="36"
                      :height="36"
                      className="rounded me-3"
                    />
                    <p class="mt-3">
                      <router-link
                        :to="'/products/detail/' + item.product_id"
                        class="text-decoration-none fw-bold"
                        style="color: #5e50a1"
                      >
                        {{
                          `${item.product_name} ${
                            item.variant_name ? ` - ${item.variant_name}` : ""
                          }`
                        }}
                      </router-link>
                    </p>
                  </div>
                  <div class="list price">
                    <div v-if="item.price_regular > item.price">
                      <span class="text-decoration-line-through">
                        {{ filters.rupiah(item.price_regular) }}
                      </span>
                      <br />
                      <span>
                        {{ filters.rupiah(item.price) }}
                      </span>
                    </div>
                    <span v-else>
                      {{ filters.rupiah(item.price) }}
                    </span>
                  </div>
                  <div class="list qty">{{ item.quantity }}</div>
                  <div class="list total">
                    {{ filters.rupiah(item.price * item.quantity) }}
                  </div>
                </div>
                <div class="d-flex mt-3 mb-3">
                  <button
                    v-if="detail == 'waiting_payment'"
                    class="btn btn-outline-danger fw-bold btn-lg text-uppercase"
                    data-bs-toggle="modal"
                    data-bs-target="#paidDetailModal"
                    @click="setData('SUBMITTED')"
                  >
                    Mark All As Paid
                  </button>
                  <!-- STATUS PAID -->
                  <div v-if="detail == 'paid'">
                    <button
                      class="btn btn-outline-danger fw-bold btn-lg me-3"
                      @click="setData('SELLER_CANCELLED', data.child_order_id)"
                      data-bs-toggle="modal"
                      data-bs-target="#paidDetailModal"
                    >
                      CANCEL ORDER
                    </button>
                    <button
                      class="btn btn-danger fw-bold btn-lg text-white"
                      @click="setData('SELLER_CONFIRMED', data.child_order_id)"
                      data-bs-toggle="modal"
                      data-bs-target="#paidDetailModal"
                    >
                      PROCESS
                    </button>
                  </div>
                  <!-- STATUS PROCESSED -->
                  <template v-else-if="detail == 'processed'" >
                      <button class="btn btn-outline-danger fw-bold btn-lg" data-bs-toggle="modal" data-bs-target="#modalCreateShipment" @click="initiatePickup(data)">
                        REQUEST PICKUP {{deliveryType === "instant" ? " - INSTANT" : ""}}
                      </button>
                  </template>
                  <div v-if="detail == 'shipment' || detail == 'delivered'" class="d-flex flex-column w-100" style="gap:1rem">
                    <!-- STATUS ON SHIPMENT-->
                    <div
                      class="d-flex w-100"
                      style="gap:1rem"
                      v-for="(order, index) in data.order"
                      :key="order"
                    >
                      <div class="col-md-4">
                        <div
                          class="d-flex justify-content-between"
                          :style="{ maxWidth: '200px' }"
                        >
                          <span
                            >Shipment AWB
                            {{ data.order.length > 1 ? index + 1 : "" }}</span
                          >
                          <div v-if="detail == 'shipment'">
                            <a
                              class="fw-bold right text-decoration-none"
                              data-bs-toggle="modal"
                              @click="setAWBCode(order.awb)"
                              style="color: #5e50a1; cursor: pointer"
                              >Change AWB</a
                            >
                          </div>
                        </div>
                        <span
                          v-if="data.service_type.toLowerCase() != 'instant'"
                          @click="
                            checkStatus(order.awb, data.location_destination, order.instantTrackUrl, order.prev_airway_bill)
                          "
                          data-bs-toggle="modal"
                          data-bs-target="#modalTrackShipment"
                          class="text-uppercase fw-bold right"
                          style="color: #5e50a1;cursor: pointer;"
                          >{{ order.awb }}</span
                        >
                        <span
                          v-else
                          @click="
                            checkStatus(order.awb, data.location_destination, order.instantTrackUrl, order.prev_airway_bill)
                          "
                          class="text-uppercase fw-bold right"
                          style="color: #5e50a1;cursor: pointer;"
                          >{{ order.awb }}</span
                        >
                      </div>
                      <div class="col-md-4" v-if="detail == 'shipment'">
                        <div>
                          <span class="text-uppercase right">E.T.A</span>
                        </div>
                        <span class="text-uppercase fw-bold right"
                          >{{ filters.dateSimple2(order.etaDate) }} On
                          {{ order.etaTimeMin }} - {{ order.etaTimeMax }}</span
                        >
                      </div>
                      <div class="d-flex flex-column justify-content-end ms-auto" style="gap:1rem">
                        <button
                          v-if="data.service_type.toLowerCase() != 'instant'"
                          class="btn btn-outline-danger fw-bold btn-lg text-uppercase"
                          data-bs-toggle="modal"
                          data-bs-target="#modalTrackShipment"
                          @click="
                            checkStatus(order.awb, data.location_destination, order.instantTrackUrl, order.prev_airway_bill)
                          "
                        >
                          {{
                            detail == "shipment"
                              ? "Track Shipment"
                              : "Tracking History"
                          }}
                        </button>
                        <button
                          v-else
                          class="btn btn-outline-danger fw-bold btn-lg text-uppercase"
                          @click="
                            checkStatus(order.awb, data.location_destination, order.instantTrackUrl, order.prev_airway_bill)
                          "
                        >
                          {{
                            detail == "shipment"
                              ? "Track Shipment"
                              : "Tracking History"
                          }}
                        </button>

                        <button id="openModalTrackShipment" v-show="false" data-bs-toggle="modal"
                          data-bs-target="#modalTrackShipment"> 
                        </button>
                        <button
                          class="w-100 ms-auto btn btn-outline-danger fw-bold btn-lg text-uppercase"
                          data-bs-toggle="modal"
                          data-bs-target="#modalOrderStatus"
                        >
                          Order Status
                        </button>
                      </div>
                    </div>
                    <!-- DELIVIRED -->
                    <div
                      v-if="detail == 'delivered' && dataReviews.length"
                      class="d-flex flex-column"
                    >
                      <span class="mb-3">Order Rating</span>
                      <template v-for="review in dataReviews" :key="review.id">
                        <div class="review-container">
                          <div class="info-container">
                            <Image
                              :src="filters.imageParse(review.product_image_url)"
                            />
                            <div class="info">
                              <span>{{ review.product_name }} </span>
                              <div class="rating">
                                <img
                                  v-for="index in review.rating"
                                  :key="index"
                                  src="@/assets/star_gold.png"
                                />
                                <img
                                  v-for="index in 5 - (review.rating || 0)"
                                  :key="index"
                                  src="@/assets/star_grey.png"
                                />
                              </div>
                            </div>
                          </div>
                          <div class="comment">
                            <span>{{ review.message }}</span>
                          </div>
                        </div>
                      </template>
                    </div>
                  </div>
                  <!-- CANCELLED -->
                  <router-link
                    v-else-if="detail == 'canceled' && data.refund.id"
                    class="btn btn-outline-danger fw-bold btn-lg text-uppercase"
                    :to="`/finance/refunds/${data.refund.id}`"
                  >
                    Check Refund
                  </router-link>
                  <!-- CHECK ORDER STATUS-->
                  <button
                    v-if="detail != 'shipment' && deliveryType != 'instant' && detail != 'delivered'"
                    class="ms-auto btn btn-outline-danger fw-bold btn-lg text-uppercase"
                    data-bs-toggle="modal"
                    data-bs-target="#modalOrderStatus"
                  >
                    Order Status
                  </button>
                </div>
              </div>
            </div>
          </div>
          <div class="me-3 ms-5" style="width: 40%">
            <div class="d-flex justify-content-between align-items-center">
              <div>Show Detail</div>
              <Dropdown
                :showShadow="false"
                :showIcon="false"
                :options="detailOptions"
                :value="detailOptionSelected"
                :containerStyle="{ width: '200px', height: '30px' }"
                :contentStyle="{ top: '24px' }"
                @onChange="(value) => (this.detailOptionSelected = value)"
              />
            </div>
            <br />
            <!-- PAYMENT DETAILS -->
            <template v-if="detailOptionSelected.value === 'payment'">
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Subtotal Produk</div>
                <div>
                  {{ filters.rupiah(data_product.subtotal_product_regular) }}
                </div>
              </div>
              <div
                class="d-flex py-1"
                v-for="data in data_product.product"
                :key="data"
                style="justify-content: space-between"
                :class="data.class"
              >
                <div>
                  {{
                    `${data.name} ${
                      data.variant_name ? ` - ${data.variant_name}` : ""
                    }`
                  }}
                </div>
                <div class="d-flex flex-column text-end">
                  <span
                    v-if="data?.price_regular > data?.price"
                    class="text-decoration-line-through"
                    >{{ filters.rupiah(data.price_regular) }}</span
                  >
                  <span>{{ filters.rupiah(data.price) }}</span>
                </div>
              </div>
              <hr />
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Potongan Produk Langsung</div>
                <div>-{{ filters.rupiah(data_product.discount_product) }}</div>
              </div>
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Voucher Diskon Produk</div>
                <div>
                  -
                  {{ filters.rupiah(data_product.discount_product_voucher) }}
                </div>
              </div>
              <div
                v-if="data_product.product_voucher"
                class="d-flex"
                style="justify-content: space-between"
              >
                <div>{{ data_product.product_voucher }}</div>
              </div>
              <hr />
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Subtotal Ongkir</div>
                <div>{{ filters.rupiah(data_product.shipment_cost) }}</div>
              </div>
              <div
                class="d-flex"
                v-for="data in data_product.ongkir"
                :key="data"
                style="justify-content: space-between"
              >
                <div>Ongkir {{ data.seller_name }}</div>
                <div>{{ filters.rupiah(data.price) }}</div>
              </div>
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Voucher Diskon Ongkir</div>
                <div>
                  -
                  {{ filters.rupiah(data_product.discount_shipment_cost) }}
                </div>
              </div>
              <div
                v-if="data_product.shipment_voucher"
                class="d-flex"
                style="justify-content: space-between"
              >
                <div>{{ data_product.shipment_voucher }}</div>
              </div>
              <hr />
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Biaya Admin</div>
                <div>
                  {{ filters.rupiah(data_product.admin_fee) }}
                </div>
              </div>
              <hr />
              <div
                class="d-flex fw-bold"
                style="justify-content: space-between"
              >
                <div>Total Pembayaran</div>
                <div>
                  {{ filters.rupiah(data_product.total) }}
                </div>
              </div>
              <hr />
              <div class="d-flex" style="justify-content: space-between">
                <div class="fw-bold text-danger">Refund</div>
                <div class="fw-bold">
                  {{ filters.rupiah(refundTotal) }}
                </div>
              </div>
              <div
                class="d-flex"
                v-for="(data, index) in data_product.refunds"
                :key="data.seller_name + index"
                style="justify-content: space-between"
              >
                <div>Refund {{ data.seller_name }}</div>
                <div>{{ filters.rupiah(data.refund) }}</div>
              </div>
            </template>
            <!-- EARNING DETAILS -->
            <template v-else>
              <template
                v-for="(revenue, index) in data_product_revenue"
                :key="revenue.id"
              >
                <div class="fw-bold" style="color: #5e50a1">
                  {{ revenue.seller_name }}
                </div>
                <div
                  class="d-flex py-1"
                  v-for="data in revenue.product"
                  :key="data"
                  style="justify-content: space-between"
                  :class="data.class"
                >
                  <div>
                    {{
                      `${data.name} ${
                        data.variant_name ? ` - ${data.variant_name}` : ""
                      }`
                    }}
                  </div>
                  <div class="d-flex flex-column text-end">
                    <span
                      v-if="data?.price_regular > data?.price"
                      class="text-decoration-line-through"
                      >{{ filters.rupiah(data.price_regular) }}</span
                    >
                    <span>{{ filters.rupiah(data.price) }}</span>
                  </div>
                </div>
                <hr />
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Subtotal Produk (sebelum diskon)</div>
                  <div>
                    {{ filters.rupiah(revenue.subtotal_product_regular) }}
                  </div>
                </div>
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Potongan Produk Langsung</div>
                  <div>
                    -
                    {{ filters.rupiah(revenue.discount_product) }}
                  </div>
                </div>
                <hr />
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Subtotal Produk (setelah diskon)</div>
                  <div>{{ filters.rupiah(revenue.subtotal_product) }}</div>
                </div>
                <hr />
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Persentase Komisi</div>
                  <div>{{ revenue.commission_percentage }}%</div>
                </div>
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Biaya Komisi</div>
                  <div>-{{ filters.rupiah(revenue.commission_fee) }}</div>
                </div>
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Biaya Admin</div>
                  <div>-{{ filters.rupiah(revenue.admin_fee) }}</div>
                </div>
                <hr />
                <div
                  class="d-flex fw-bold"
                  style="justify-content: space-between"
                >
                  <div>Total Pendapatan</div>
                  <div>
                    {{ filters.rupiah(revenue.seller_revenue) }}
                  </div>
                </div>
                <hr
                  v-if="index !== data_product_revenue.length - 1"
                  style="border-style: dashed"
                />
              </template>
            </template>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL AWB -->
    <TemplateModal :show="showModal" @handleClose="showModal=false">
      <div class="modal-content">
        <div class="modal-header">
          <p class="fw-bold modal-title">Change AWB</p>
        </div>
        <div class="modal-body m-3">
          <div class="row">
            <label class="col-lg-12 col-form-label text-start">
              Current Shipment AWB
            </label>
            <label
              class="col-lg-12 col-form-label text-start text-uppercase"
              style="color: #5e50a1"
            >
              {{ data.airway_bill }}
            </label>
          </div>
          <div class="d-flex flex-column">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Enter New AWB
              </label>
              <div class="col-md-12" v-if="!setAWB">
                <input type="text" v-model="newAWB" class="form-control" />
              </div>
              <label
                v-else
                class="col-lg-12 col-form-label text-start text-uppercase"
                style="color: #5e50a1"
              >
                {{ newAWB }}
              </label>
            </div>
            <span v-if="errors.changeAWB" class="text-danger mt-2">{{
              errors.changeAWB
            }}</span>
          </div>
          <div class="flex mt-5">
            <div
              v-if="!data.service_type?.toUpperCase()?.includes('INSTANT') && data.latest_status && data.latest_status != 'PRJL'"
              class="warning rounded mb-3"
            >
              <img src="@/assets/ic_info_yellow.png" alt="icon-info" />
              <span> Change AWB only available for <b>PRJL</b> status </span>
            </div>
            <div class="warning rounded mb-3" v-if="data.is_dropshipper">
              <img src="@/assets/ic_info_yellow.png" alt="icon-info" />
              <span>
                This is a <b>Dropshipper Order</b>. Please make sure Sender Name
                and Sender Phone Number on the new Printed AWB are as per
                requested, if any.
              </span>
            </div>
            <div class="d-flex col-md-12">
              <div class="col-md-6 me-3">
                <button
                  type="button"
                  class="btn btn-secondary bg-white text-body fw-bold me-1 text-uppercase col-md-11"
                  @click="showModal = false"
                >
                  Cancel
                </button>
              </div>
              <div class="col-md-6 ms-2">
                <button
                  type="button"
                  class="btn btn-danger fw-bold text-white text-uppercase col-md-11"
                  v-show="!setAWB"
                  :disabled="(!newAWB || data.latest_status != 'PRJL') && !data.service_type?.toUpperCase()?.includes('INSTANT')"
                  @click="setAWB = true"
                >
                  Change AWB
                </button>
                <button
                  v-show="setAWB"
                  type="button"
                  class="btn btn-danger fw-bold text-white text-uppercase col-md-11"
                  @click="changeAWB"
                >
                  Confirm Change AWB
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </TemplateModal>
    <!-- MODAL CREATE SHIPMENT -->
    <div
      class="modal fade"
      id="modalCreateShipment"
      tabindex="-1"
      aria-labelledby="modalCreateShipmentLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p
              class="fw-bold modal-title fsize-16 text-uppercase"
              id="modalCreateShipmentLabel"
            >
              {{deliveryType === "instant" ? "Request Instant Driver" : "Request Pickup"}}
            </p>
          </div>
          <div class="modal-body m-3">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Receiver
              </label>
            </div>
            <div class="row fw-bold">
              <label class="col-lg-12 col-form-label text-start">
                {{ locationDestination.name_person }}
              </label>
              <label class="col-lg-12 col-form-label text-start">
                {{
                  locationDestination ? locationDestination.address_detail : ""
                }},
                {{ locationDestination ? locationDestination.district : "" }}
                {{ locationDestination ? locationDestination.city : "" }}
                {{ locationDestination ? locationDestination.province : "" }}
              </label>
            </div>
            <div class="row mb-3">
              <GMapMap
                :center="center"
                :zoom="16"
                class="ms-1"
                map-type-id="terrain"
                ref="myMapRef"
                :cluster="{ options: { styles: clusterStyle } }"
                style="width: 460px; height: 200px"
                :options="{
                  fullscreenControl: false,
                  styles: mapStyle,
                  mapTypeControl: false,
                  streetViewControl: false,
                  keyboardShortcuts: false,
                  controlSize: 23,
                }"
              >
                <GMapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :icon="require(`@/assets/images/paxel-marker.svg`)"
                />
              </GMapMap>
            </div>
            <template v-if="deliveryType != 'instant'">
              <div class="row">
                <label class="col-lg-12 col-form-label text-start">
                  Pickup Date
                </label>
                <div class="col-md-12">
                  <select v-model="pickup_date" :style="time_slot.value == null ?'color:red':''" class="form-control">
                    <option
                      style="color:black" 
                      :style="item.timeslot == null ?'color:red !important':''"
                      v-for="item in dateSlot"
                      :key="item"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div class="row">
                <label class="col-lg-12 col-form-label text-start">
                  Time Slot
                </label>
                <div class="col-md-12">
                  <select
                    v-model="time_slot.value"
                    class="form-control"
                    :disabled="!pickup_date"
                    :style="time_slot.value == null ?'color:red':''"
                  >
                    <option
                      :style="time_slot.value == null ?'color:red':''"
                      v-for="item in timeSlot"
                      :key="item.label"
                      :value="item.value"
                    >
                      {{ item.label }}
                    </option>
                  </select>
                </div>
              </div>
              <div
                class="alert alert-warning my-4"
                :style="{ padding: '5px 12px' }"
                role="alert"
                v-if="multipleShipment"
              >
                <font-awesome-icon
                  icon="fa-solid fa-circle-info"
                  class="me-1 text-warning"
                />
                This order will have multiple shipments (Split AWB)
              </div>
            </template>
            <div class="row mt-3">
              <div class="d-flex col-md-12">
                <div class="col-md-6 me-3">
                  <button
                    type="button"
                    class="btn btn-secondary bg-white text-body fw-bold me-1 text-uppercase col-md-11"
                    data-bs-dismiss="modal"
                  >
                    Cancel
                  </button>
                </div>
                <div class="col-md-6 ms-2">
                  <button
                    type="button"
                    :class="deliveryType!='instant' && (!time_slot?.value || !pickup_date) ? 'disabled' : ''"
                    class="btn btn-danger fw-bold text-white text-uppercase col-md-11"
                    data-bs-dismiss="modal"
                    @click="createAWB"
                  >
                    {{deliveryType == 'instant'?'Order Driver':'Request Pickup'}}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL TRACK SHIPMENT -->
    <div
      class="modal fade"
      id="modalTrackShipment"
      tabindex="-1"
      aria-labelledby="modalTrackShipmentLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title" id="modalTrackShipmentLabel">
              Shipment Tracking
            </p>
          </div>
          <div class="modal-body m-2">
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Shipment AWB
              </label>
              <label
                class="col-lg-12 col-form-label text-start text-uppercase"
                style="color: #5e50a1"
              >
                {{ awb }}
              </label>
            </div>
            <div class="row">
              <label class="col-lg-12 col-form-label text-start">
                Receiver
              </label>
              <label class="col-lg-12 col-form-label fw-bold text-start">
                {{
                  locationDestination ? locationDestination.address_detail : ""
                }},
                {{ locationDestination ? locationDestination.district : "" }}
                {{ locationDestination ? locationDestination.city : "" }}
                {{ locationDestination ? locationDestination.province : "" }}
              </label>
            </div>
            <div class="row mb-3">
              <GMapMap
                :center="center"
                :zoom="16"
                class="ms-1"
                map-type-id="terrain"
                ref="myMapRef"
                :cluster="{ options: { styles: clusterStyle } }"
                style="width: 460px; height: 200px"
                :options="{
                  fullscreenControl: false,
                  styles: mapStyle,
                  mapTypeControl: false,
                  streetViewControl: false,
                  keyboardShortcuts: false,
                  controlSize: 23,
                }"
              >
                <GMapMarker
                  :key="index"
                  v-for="(m, index) in markers"
                  :position="m.position"
                  :icon="require(`@/assets/images/paxel-marker.svg`)"
                />
              </GMapMap>
            </div>
            <div class="row">
              <div class="col-md-12">
                <h4>History</h4>
                <ul class="timeline">
                  <li v-for="log in logShipment" :key="log">
                    <div class="bar"/>
                    <div class="d-flex">
                      <span class="fw-bold col-md-10 justify-content-start">{{
                        log ? log.status_description : ""
                      }}</span>
                      <div
                        class="d-flex flex-column col-md-2 justify-content-end text-end"
                      >
                        <span>
                          {{ filters.dateAndMonthUtc(log.created_at) }}
                        </span>
                        <span>
                          {{ filters.timeSimpleUtc(log.created_at) }} WIB
                        </span>
                      </div>
                    </div>
                    <p>
                      {{ log.location ? log.location.district : "" }},
                      {{ log.location ? log.location.regency : "" }}
                    </p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
    <!-- MODAL ORDER STATUS -->
    <div
      class="modal fade"
      id="modalOrderStatus"
      tabindex="-1"
      aria-labelledby="modalOrderStatusLabel"
      aria-hidden="true"
    >
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <p class="fw-bold modal-title" id="modalOrderStatusLabel">
              Order Status
            </p>
          </div>
          <div class="modal-body m-2">
            <div class="row">
              <div class="col-md-12">
                <h4>History</h4>
                <ul class="timeline mt-3">
                  <template 
                    v-for="order in historyOrder"  
                    :key="order.label"
                  >
                    <li 
                      v-if="order.date"
                      :class="{
                        cancel: order.status == 'cancel'
                      }"
                    >
                      <div 
                        class="bar" 
                        :class="{
                          cancel: order.status == 'cancel'
                        }"
                      />
                      <div class="d-flex">
                        <span class="fw-bold col-md-10 justify-content-start">{{
                          order ? order.label : ""
                        }}</span>
                        <div
                          class="ms-auto d-flex flex-column col-md-2 justify-content-end text-end"
                        >
                          <span>
                            {{ filters.dateAndMonth(order.date)}}
                          </span>
                          <span>
                            {{ filters.timeSimple(order.date) }} WIB
                          </span>
                        </div>
                      </div>
                    </li>
                    <!-- show pending style when no date, and make sure hide status that below canceled if exist -->
                    <li 
                      v-if="!order.date && order.status != 'cancel'  && historyOrder.find(x=> !x.date && x.status == 'cancel')"
                      class="pending"
                    >
                      <div class="bar pending"/>
                      <div class="d-flex">
                        <span class="fw-bold col-md-10 justify-content-start">{{
                          order ? order.label : ""
                        }}</span>
                        <div
                          class="ms-auto d-flex flex-column col-md-2 justify-content-end text-end"
                        >
                          <span>
                            -
                          </span>
                        </div>
                      </div>
                    </li>
                  </template>
                </ul>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary bg-white text-body fw-bold me-3 border border-0 text-uppercase"
              data-bs-dismiss="modal"
            >
              Close
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import CardInfo from "@/components/CardInfo.vue";
import ModalConfirm from "@/components/ModalConfirm.vue";
import TemplateModal from "@/components/TemplateModal.vue";
import Dropdown from "@/components/Dropdown.vue";
import Image from "@/components/Image.vue";

import moment from "moment";

export default {
  components: {
    CardInfo,
    ModalConfirm,
    TemplateModal,
    Dropdown,
    Image,
  },
  created() {
    const listRoute = this.$route.path.split("/");
    this.id = listRoute[listRoute.length - 1];
    this.selectedId = listRoute[listRoute.length - 1];
  },
  mounted() {
    this.onMountFetch();
  },
  data() {
    return {
      deliveryType: "sameday",
      showModal: false,
      errors: {},
      reason: "",
      showModalReason: false,
      detailOptions: [
        {
          label: "Payment Details",
          value: "payment",
        },
        {
          label: "Earning Details",
          value: "earning",
        },
      ],
      detailOptionSelected: {
        label: "Payment Details",
        value: "payment",
      },
      typeOrder: "",
      detail: "",
      id: "",
      selectedId: "",
      selectedOrder: {},
      data_product: {
        subtotal_product_regular: 0,
        subtotal_product: 0,
        shipment_cost: 0,
        discount_product: 0,
        discount_product_voucher: 0,
        discount_shipment_cost: 0,
        admin_fee: 0,
        refunds: [],
        total: 0,
        ongkir: [],
        product: [],
      },
      data_product_revenue: [],
      dataSellerDetail: [],
      dataSeller: [
        {
          value: "",
          color: "green",
          url: "",
          class: "fsize-12",
          color_text: "#5E50A1",
        },
        {
          value: "",
          color: "yellow",
          url: "",
          class: "fsize-12",
          color_text: "#5E50A1",
        },
        {
          value: "",
          color: "yellow",
          url: "",
          class: "fsize-12",
          color_text: "#5E50A1",
        },
      ],
      locationDestination: {},
      time_slot: {},
      pickup_date: "",
      payment_method: "",
      status: "",
      awb: "",
      newAWB: "",
      setAWB: false,
      history: [],
      shipment: {},
      data: {},
      dataReviews: [],
      multipleShipment: false,
      dateSlot: [],
      timeSlot: [],
      mapStyle: [],
      center: {
        lat: -6.2,
        lng: 106.8456,
      },
      markers: [
        {
          position: {
            lat: -6.2,
            lng: 106.8456,
          },
        },
      ],
      clusterStyle: [
        {
          url: "https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m1.png",
          width: 56,
          height: 56,
          textColor: "#fff",
        },
      ],
      logShipment: [],
      trackUrlExpiredThreshold:5, //in hours
    };
  },
  watch: {
    pickup_date(value) {
      if (value) {
        let timeSlotTemp = this.dateSlot.find((x) => x.value == value)?.timeslot;
        if(timeSlotTemp?.length > 0){
          this.time_slot = {
              value: timeSlotTemp[0],
              label: timeSlotTemp[0].split(" - ").map(x=>{
                  return x.substring(0,5)
                }).join(" - ")
            }
          this.timeSlot = timeSlotTemp.map((time) => {
            return {
              value: time,
              label: time
                .split(" - ")
                .map((x) => {
                  return x.substring(0, 5);
                })
                .join(" - "),
            };
          });
        } else {
            this.time_slot = {
              value: null,
              label: "Ops. Libur"
            }
            this.timeSlot = [{
              value: null,
              label: "Ops. Libur"
            }]
          }
      }
    },
    "$route.query.detail"(value) {
      if (this.$route.path === `/order/orders/${this.id}` && value) {
        this.onMountFetch();
      }
    },
  },
  computed: {
    refundTotal() {
      if (this.data_product.refunds.length) {
        return this.data_product.refunds.reduce((total, data) => {
          return (total += data?.refund);
        }, 0);
      }
      return 0;
    },
    statusModal() {
      if (this.status == "SUBMITTED") return "Mark All as Paid";
      if (this.status == "SELLER_CANCELLED") return "Cancel";
      if (this.status == "SELLER_CONFIRMED") return "Process";
      return this.status?.split("_")[1] || "";
    },
    order_statuses() {
      return this.data?.order_statuses || []
    },
    order_seller_statuses() {
      return this.data?.order_seller_statuses || []
    },
    historyOrder() {
      let history = [
        {
          label: "Order dibatalkan",
          type: ["SELLER_CANCELLED", "PAYMENT_FAILED", "BUYER_CANCELLED"],
          date: "",
          status: "cancel"
        },
        {
          label: "Order kamu diterima",
          type: ["COMPLETED"],
          date: "",
          status: "complete"
        },
        {
          label: "Order dikirim",
          type: ["BEING_DELIVERED", "PICKUP_REQUESTED"],
          date: "",
          status: "delivery"
        },
        {
          label: "Order diproses penjual",
          type: ["SELLER_CONFIRMED"],
          date: "",
          status: "process"
        },
        {
          label: "Order berhasil dibayar",
          type: ["PAYMENT_SUCCESS", "SELLER_CHECKED"],
          date: "",
          status: "paid"
        },
        {
          label: "Menunggu Pembayaran",
          type: ["SUBMITTED", "PAYMENT_WAITING"],
          date: "",
          status: "waiting"
        },
      ]
      let statuses = [...this.order_statuses, ...this.order_seller_statuses]

        history.map((order) => {
          let foundOrder;
          let x = 0;
          while (x < order.type.length && !foundOrder) {
            const element = order.type[x];
            foundOrder = statuses.find((y) => y.status == element);
            x++;
          }
          if (foundOrder) {
            order.date = foundOrder.date;
          }
          return order;
        });

        return history
      }
    },
    methods: {
      parseToTimeString(number) {
        if(typeof number == "string") return number
        const hours = Math.floor(number / 100);
        const minutes = number % 100;
        const timeString = `${hours}:${minutes.toString().padStart(2, '0')}`;
        return timeString;
      },
      parseStatus(detail) {
        if (detail == "waiting_payment") return "Waiting Payment";
        if (detail == "paid") return "Paid";
        if (detail == "processed") return "Processed";
        if (detail == "shipment") return "On Shipment";
        if (detail == "delivered") return "Delivered";
        if (detail == "canceled") return "Cancelled";
        return detail;
      },
      parseColor(status) {
        if (status == "Waiting Payment") return "#FFB200";
        if (
          status == "Paid" ||
          status == "Processed" ||
          status == "On Shipment" ||
          status == "Delivered"
        )
          return "#30CB9D";
        if (status == "Cancelled") return "#ED413F";

        return "";
      },
      onMountFetch() {
        let param_detail = this.$route.query.detail;
        this.detail = param_detail;
        this.typeOrder = this.$route.query.type_order;
        console.log("TYPE ORDER : ", this.typeOrder);
        this.getData();
      },
      async getData() {
        let response = {};
        let reviews = [];
        let status = "";
        // handle status naming here
        status = this.parseStatus(this.detail);
        this.dataSeller[2].color_text = this.parseColor(status);

      if (this.typeOrder == "orderseller") {
        const parentId = this.id.split("-")[0];
        const res = await this.$store.dispatch("order/getOneOrder", {
          id: parentId,
        });
        let parentOrder = res.item;
        console.log("RESPONSE", {parentOrder});

          let childIds = parentOrder?.order_sellers.map((x) => x.id);
          let payload = {
            size: 100,
            ids: childIds,
          };
          const childsRes = await this.$store.dispatch(
            "order/getAllOrderSeller",
            payload
          );
          // update order sellers parent, with api /orderseller
          parentOrder.order_sellers = childsRes.items;
          reviews = childsRes.reviews || [];

        // set response value
        response = res.item.order_sellers?.find((x) => x.id == this.id);
        this.deliveryType = response.service_type.toLowerCase()
        this.dataSeller[0].value = response.buyer_name
          ? response.buyer_name
          : "";
        this.dataSeller[1].value = response.seller_store_name
          ? response.seller_store_name
          : "";
        this.dataSeller[2].value = status;
        if (this.detail == "canceled") {
          if (response.cancel_by) {
            this.dataSeller[2].value =
              this.dataSeller[2].value +
              ` by ${this.filters.capitalize(response.cancel_by)}`;
          }
          this.dataSeller[3] = {
            value: response.cancel_reason || "-",
            color: "red",
            url: "",
            color_text: "#000",
            class: "fsize-12",
            style: "max-width:250px",
          };
        }
        if (response.is_dropshipper) {
          let dropshipper_name = response.dropshipper_name
            ? response.dropshipper_name
            : "";
          let dropshipper_contact = response.dropshipper_contact
            ? response.dropshipper_contact
            : "";
          let dropshipper =
            dropshipper_name + " " + "(" + dropshipper_contact + ")";
          this.dataSeller[4] = {
            value: dropshipper,
            color: "green",
            url: "",
            color_text: "#000",
            class: "fsize-12",
          };
        }
        let receiverName = response.location_destination?.name_person
          ? response.location_destination.name_person
          : "";
        let receiverPhone = response.location_destination?.phone_number
          ? response.location_destination.phone_number
          : "";
        let receiver = receiverName + " " + "(" + receiverPhone + ")";
        this.dataSeller[5] = {
          value: receiver,
          color: "green",
          url: "",
          color_text: "#5E50A1",
          class: "fsize-12",
        };
        this.dataSellerDetail = [
          {
            service_type: response.service_type,
            seller_name: response.seller_store_name
              ? response.seller_store_name
              : "",
            seller_location: response.location_origin
              ? response.location_origin.city
              : "",
            location_destination: response?.location_destination || {},
            child_order_id: response.id ? response.id : "",
            seller_photo_url: response?.seller_photo_url || "",
            refund: response.refund,
            product_items: response.product_items,
            order: response.order_packages.map((x) => {
              let ress = {
                awb: x.airway_bill,
                etaDate: x.estimation_arrival_date
                  ? x.estimation_arrival_date
                  : "",
                etaTimeMin: x.estimation_arrival_min_time
                  ? x.estimation_arrival_min_time
                  : "",
                etaTimeMax: x.estimation_arrival_max_time
                  ? x.estimation_arrival_max_time
                  : "",
                instantTrackUrl:x.instant_track_url,
                prev_airway_bill:x.prev_airway_bill,
              };

                return ress;
              }),
            },
          ];

          // update ETA for each field order in dataSellerDetail if detail == 'shipment'

          let dataSellerDetailOrder = this.dataSellerDetail?.[0]?.order || []
          if(this.detail == 'shipment' && dataSellerDetailOrder.length) {
            try {
              for(let i = 0; i < dataSellerDetailOrder.length; i++){
                let item = dataSellerDetailOrder[i]
                const payload = {
                  shipment_code: item.awb,
                };
                let res = await this.$store.dispatch("order/getShipmentStatus", payload);
                let resOrder = res?.data?.[0]
                let updatedOrder = {
                  awb: item.awb,
                  etaDate: resOrder?.delivery_address?.delivery_date,
                  etaTimeMin: this.parseToTimeString(resOrder?.delivery_address?.min_time),
                  etaTimeMax: this.parseToTimeString(resOrder?.delivery_address?.max_time)
                }

                this.dataSellerDetail[i] = {
                  ...this.dataSellerDetail[i],
                  order: [{ ...item, ...updatedOrder}]
                }

              }
            } catch (err){
              console.log("Error on updating ETA", {err})
            }
          }


          // handle payment details value from it parents
          let productParent = [];

          parentOrder.order_sellers.forEach((order) => {
            order.product_items.forEach((item) => {
              productParent.push({
                name: item.product_name,
                variant_name: item.variant_name,
                price: item.price * item.quantity,
                price_regular: item.price_regular * item.quantity,
              });
            });
          });

          const calcValue = (key) =>
            parentOrder.order_calculation_details.find((x) => x.type == key)
              .nominal;
          const codeVoucher = parentOrder.order_sellers.reduce((obj, data) => {
            let product_voucher =
              data.order_seller_pricing.code_discount_product_voucher;
            let shipment_voucher =
              data.order_seller_pricing.code_discount_shipment_voucher;
            if (product_voucher) obj.product_voucher = product_voucher;
            if (shipment_voucher) obj.shipment_voucher = shipment_voucher;
            return obj;
          }, {});
          this.data_product = {
            subtotal_product_regular: calcValue("product_subtotal"),
            subtotal_product: calcValue("product_subtotal"),
            shipment_cost: calcValue("shipping_subtotal"),
            discount_product: calcValue("product_discount"),
            discount_product_voucher: calcValue("voucher_discount"),
            discount_shipment_cost: calcValue("shipping_discount"),
            admin_fee: calcValue("admin_fee"),
            refunds: parentOrder.order_sellers.map((x) => ({
              seller_name: x.seller_store_name,
              refund: x?.refund?.order_seller_pricing?.total_payment || 0,
            })),
            total: calcValue("total_paid"),
            ongkir: parentOrder.order_sellers.map((x) => {
              let ongkir = {
                seller_name: x.seller_store_name,
                price: x.order_seller_pricing.shipment_cost,
              };

              return ongkir;
            }),
            product: productParent,
            ...codeVoucher,
          };

          // handle earning details value from current child
          let productChild = [];
          response.product_items.forEach((item) => {
            productChild.push({
              name: item.product_name,
              variant_name: item.variant_name,
              price: item.price * item.quantity,
              price_regular: item.price_regular * item.quantity,
            });
          });
          const pricing = response?.order_seller_pricing;
          this.data_product_revenue = [
            {
              id: response?.id,
              seller_name: response?.seller_store_name,
              subtotal_product_regular:
                pricing?.subtotal_product_price_regular || 0,
              subtotal_product: pricing?.subtotal_product_price || 0,
              discount_product: pricing?.subtotal_product_discount || 0,
              discount_product_voucher: pricing?.discount_product_voucher || 0,
              admin_fee: pricing?.admin_fee || 0,
              commission_fee: pricing?.commission_fee || 0,
              commission_percentage: pricing?.commission_percentage || 0,
              seller_revenue: pricing?.seller_revenue || 0,
              product: productChild,
            },
          ];
        } else {
          const res = await this.$store.dispatch("order/getOneOrder", {
            id: this.id,
          });
          response = res.item;
          console.log("RESPONSE");
          console.log(response);

          // this for handling order besides the waiting payment_method
          // get parent order and replace with the order_sellers field with api below
          if (this.detail != "waiting_payment") {
            let childIds = response?.order_sellers.map((x) => x.id);
            let payload = {
              size: 100,
              ids: childIds,
            };
            const childsRes = await this.$store.dispatch(
              "order/getAllOrderSeller",
              payload
            );
            // update order sellers parent, with api /orderseller
            response.order_sellers = childsRes.items;
            reviews = childsRes.reviews || [];
          }

        this.dataSeller[0].value = response.buyer_name
          ? response.buyer_name
          : "";
        this.dataSeller[1].value =
          response.order_sellers.length > 1
            ? `${response.order_sellers.length} Sellers`
            : response.order_sellers[0].seller_store_name;
        this.dataSeller[2].value = status;
        this.dataSellerDetail = response.order_sellers.map((x) => {
          let res = {
            service_type: x.service_type,
            seller_name: x.seller_store_name,
            seller_location: x.location_origin.city,
            location_destination: x?.location_destination || {},
            child_order_id: x.id,
            seller_photo_url: x?.seller_photo_url || "",
            refund: x.refund,
            product_items: x.product_items,
            order: x.order_packages.map((z) => {
              let ress = {
                awb: z.airway_bill,
                etaDate: z.estimation_arrival_date
                  ? z.estimation_arrival_date
                  : "",
                etaTimeMin: z.estimation_arrival_min_time
                  ? z.estimation_arrival_min_time
                  : "",
                etaTimeMax: z.estimation_arrival_max_time
                  ? z.estimation_arrival_max_time
                  : "",
              };

                return ress;
              }),
            };

            return res;
          });
          if (response.is_dropshipper) {
            let dropshipper_name = response.dropshipper_name
              ? response.dropshipper_name
              : "";
            let dropshipper_contact = response.dropshipper_contact
              ? response.dropshipper_contact
              : "";
            let dropshipper =
              dropshipper_name + " " + "(" + dropshipper_contact + ")";
            this.dataSeller[4] = {
              value: dropshipper,
              color: "green",
              url: "",
              color_text: "#000",
              class: "fsize-12",
            };
          }

          let receiverName = response?.order_sellers[0]?.location_destination
            .name_person
            ? response?.order_sellers[0]?.location_destination.name_person
            : "";
          let receiverPhone = response?.order_sellers[0]?.location_destination
            .phone_number
            ? response?.order_sellers[0]?.location_destination.phone_number
            : "";
          let receiver = receiverName + " " + "(" + receiverPhone + ")";
          this.dataSeller[5] = {
            value: receiver,
            color: "green",
            url: "",
            color_text: "#5E50A1",
            class: "fsize-12",
          };
          let product = [];

          for (let x = 0; x < response.order_sellers.length; x++) {
            const element = response.order_sellers[x];
            const productItems = element.product_items;
            for (let y = 0; y < productItems.length; y++) {
              const eleProduct = productItems[y];
              product.push({
                name: eleProduct.product_name,
                variant_name: eleProduct.variant_name,
                price: eleProduct.price * eleProduct.quantity,
                price_regular: eleProduct.price_regular * eleProduct.quantity,
              });
            }
          }

          const calcValue = (key) =>
            response.order_calculation_details.find((x) => x.type == key).nominal;
          const codeVoucher = response?.order_sellers.reduce((obj, data)=>{
            let product_voucher = data.order_seller_pricing.code_discount_product_voucher
            let shipment_voucher = data.order_seller_pricing.code_discount_shipment_voucher
            if(product_voucher) obj.product_voucher = product_voucher
            if(shipment_voucher) obj.shipment_voucher = shipment_voucher
            return obj
          }, {})
          this.data_product = {
            subtotal_product_regular: calcValue("product_subtotal"),
            subtotal_product: calcValue("product_subtotal"),
            shipment_cost: calcValue("shipping_subtotal"),
            discount_product: calcValue("product_discount"),
            discount_product_voucher: calcValue("voucher_discount"),
            discount_shipment_cost: calcValue("shipping_discount"),
            admin_fee: calcValue("admin_fee"),
            refunds: [],
            total: calcValue("total_paid"),
            ongkir: response.order_sellers.map((x) => {
              let ongkir = {
                seller_name: x.seller_store_name,
                price: x.order_seller_pricing.shipment_cost,
              };

              return ongkir;
            }),
            product: product,
            ...codeVoucher
          };

          (this.data_product_revenue = response.earning_details.map((x) => {
            return {
              id: x.id,
              seller_name: x.seller_store_name,
              subtotal_product_regular: x?.subtotal_product_price_regular || 0,
              subtotal_product: x?.subtotal_product_price || 0,
              discount_product: x?.subtotal_product_discount || 0,
              discount_product_voucher: x?.discount_product_voucher || 0,
              admin_fee: x?.admin_fee || 0,
              commission_fee: x?.commission_fee || 0,
              commission_percentage: x?.commission_percentage || 0,
              seller_revenue: x?.total_revenue || 0,
              product: x.product_list.map((x) => ({
                name: x.product_name,
                variant_name: x.variant_name,
                price: x.price * x.quantity,
                price_regular: x.price_regular * x.quantity,
              })),
            };
          })),
            (this.payment_method = response.payment_method);
        }

        this.data = response;
        this.dataReviews = reviews;
      },
      setData(status, selected) {
        this.status = status;
        this.reason = ""
        if (selected) this.selectedId = selected;
      },
      handleModalConfirm() {
        if(this.status == 'SELLER_CANCELLED'){
          this.showModalReason = true
        }else{
          this.changeStatus()
        }
      },
      async changeStatus() {
        let payload = {};
        let url = "";
        let statusQuery = "";
        try {
          if (this.status == "SUBMITTED") {
            payload["order_id"] = this.id;
            payload["payment_method"] = this.data.payment_method;
            url = "order/changeStatusOrder";
            statusQuery = "Paid";
          }
          if (this.status == "SELLER_CONFIRMED") {
            payload["order_seller_id"] = this.selectedId;
            payload["reason"] = "";
            url = "order/processOrderSeller";
            statusQuery = "Processed";
          }

          if (this.status == "SELLER_CANCELLED") {
            payload["order_seller_id"] = this.selectedId;
            payload["reason"] = this.reason;
            url = "order/cancelOrderSeller";
            statusQuery = "Cancelled";
          }

          await this.$store.dispatch(url, payload);

        setTimeout(() => {
          this.$router.replace(`/order/orders?status=${statusQuery}`);
        }, 1500);
      } catch (error) {
        console.log("ERROR : ", error);
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        });
      }
    },
    async checkStatus(awb, destination, instant_track_url,prev_airway_bill) {
      let service_type = this.data.service_type
      console.log("AWB : ", awb);
      this.awb = awb;
      this.locationDestination = destination;
      const payload = {
        // shipment_code: 'ECOM.PAXELTEST-20220822-1-RP1W36'
        shipment_code: awb,
      };
      this.center = {
        lat: destination.lat_lng[0],
        lng: destination.lat_lng[1],
      };

      this.markers = [
        {
          position: {
            lat: destination.lat_lng[0],
            lng: destination.lat_lng[1],
          },
        },
      ];
      try {
        this.shipment = await this.$store.dispatch(
          "order/getShipmentStatus",
          payload
        );
        const logShipment = this.$store.getters["order/ShipmentLogs"];
        this.logShipment =
          logShipment.length > 0 ? logShipment : this.logShipment;
          console.log(service_type)
          if(service_type.toLowerCase() == 'instant'){
            this.checkIsUrlExpired(instant_track_url, prev_airway_bill)
          }
      } catch (error) {
        console.log("ERROR : ", error);
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        });
      }
    },
    async setAWBCode(awb) {
      this.showModal = true;
      this.errors = {};
      this.newAWB = "";
      this.setAWB = false;
      this.data.airway_bill = awb;
      const payload = {
        shipment_code: awb,
      };
      try {
        const res = await this.$store.dispatch(
          "order/getShipmentStatus",
          payload
        );
        const shipmentData = res.data[0];
        this.data.latest_status = shipmentData.latest_status;
        console.log({ data: this.data });
      } catch (err) {
        console.log(err);
      }
    },
    async changeAWB() {
      const payload = {
        order_seller_id: this.id,
        new_airway_bill: this.newAWB,
        old_airway_bill: this.data.airway_bill,
      };
      try {
        await this.$store.dispatch("order/changeOrderAWB", payload);
        this.errors = {};
        this.showModal = false;
        setTimeout(() => {
          window.location.reload(true);
        }, 1500);
      } catch (error) {
        console.log("ERROR : ", error);
        this.errors = { changeAWB: "Invalid AWB" };
        this.setAWB = false;
      }
    },
    async createAWB() {
      let pickup_datetime = "";
      if(this.deliveryType != "instant"){
        var timeslot = this.time_slot.value.split(" - ");
        pickup_datetime =  `${this.pickup_date} ${timeslot[0]}`
      }else{
        pickup_datetime = moment(new Date).add(1,'minutes').locale("Id").format('YYYY-MM-DD HH:mm:ss'); //add 1 minutes as buffer process so pickup > created at
      }
      const payload = {
        order_seller_id: this.selectedOrder.child_order_id,
        payment_type: "CRD",
        is_high_value: false,
        pickup_datetime: pickup_datetime,
        need_insurance: false,
        note: "",
        is_dropship: false,
        dropshipper: null,
        service_type: this.deliveryType.toUpperCase(),
      };

        try {
          await this.$store.dispatch("order/createAWB", payload);

          setTimeout(() => {
            this.$router.push("/order/orders?status=On%20Shipment");
          }, 500);
        } catch (error) {
          console.log("ERROR : ", error);
          this.$swal({
            title: error.response?.data?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          });
        }
      },
      async initiatePickup(data) {
        const payload = {
          order_seller_id: data.child_order_id,
        };
        this.selectedOrder = data;
        const destination = data.location_destination;
        this.locationDestination = destination;

        this.center = {
          lat: destination.lat_lng[0],
          lng: destination.lat_lng[1],
        };

        this.markers = [
          {
            position: {
              lat: destination.lat_lng[0],
              lng: destination.lat_lng[1],
            },
          },
        ];

        this.multipleShipment = Boolean(data?.order?.length > 1);

      // reset form
      this.time_slot = {};
      this.pickup_date = "";
      if (this.deliveryType == "instant") return
      try {
        const res = await this.$store.dispatch("order/getTmeSlot", payload);
        console.log(res);

        this.dateSlot = res.map((x) => ({
          value: x.date,
          label: moment(x.date).format("DD MMM YYYY"),
          timeslot: x.timeslot,
        }));
      } catch (error) {
        console.log("ERROR : ", error);
        this.$swal({
          title: error.response?.data?.errorMessage || error.message,
          icon: "warning",
          timer: 2000,
        });
      }
    },
    showTrackUrl(instant_track_url){
      //if available open webview track shipment
      if(instant_track_url){
        window.open(instant_track_url, "_blank")
      }else{
        //if not availalbe show alert info, because its posible shipment was created but system still looking for driver, so track url still unavailable
        this.$swal({
          title: "Lacak paket belum tersedia",
          icon: "warning",
          timer: 2000,
        });
      }
    },
    checkIsUrlExpired(instant_track_url, prev_airway_bill){
      let log = this.logShipment;
      //check order is ever use change awb? if it was, show default tracking (because webhook for new track url was not updated)
      if(prev_airway_bill == null){
        //find selected data by shipment code
        let find =  log.find(o => o.status === 'COL');
        if(find){
          let current_time = moment(new Date).unix();
          let threshold_time = moment.utc(find.created_at).add(this.trackUrlExpiredThreshold,'hours').unix();
          console.log(current_time,threshold_time )
          //compare current time and time shipping saved the track url, and check is expired or not
          if(current_time > threshold_time){
            //if already expired, show existing function to show history
            document.getElementById("openModalTrackShipment")?.click()
          }else{
            //if not expired, show webview to track shipment from gosend
            this.showTrackUrl(instant_track_url)
          }
        }else{
          //mean status log not yet reach to COL or track url not saved yet in db
          document.getElementById("openModalTrackShipment")?.click()
        }
      }else{
        document.getElementById("openModalTrackShipment")?.click()
      }
    },
  },
};
</script>

<style scoped lang="scss">
.warning {
  border: 1px solid #ffb003 !important;
  background-color: #ffe9b9;
  display: flex;
  align-items: center;
  gap: 12px;
  min-height: 28px;
  padding: 3px 12px;
}
.product-list {
  display: flex;
  padding: 1rem;
  background-color: #f9f9fc;
  border-bottom: 2px solid #ebedf3;

  &.header {
    background-color: #f3f2f8;
  }

  .list {
    display: flex;
    align-items: center;

    &.product {
      width: 34%;
    }
    &.price {
      width: 35%;
    }
    &.qty {
      width: 22%;
    }
    &.total {
      width: 9%;
    }
  }
}

.review-container {
  display: flex;
  margin-bottom: 24px;

  .info-container {
    display: flex;
    flex: 1;
    margin-right: 10px;

    img {
      width: 36px;
      height: 36px;
      border-radius: 6px;
    }
    .info {
      margin-left: 16px;
      font-weight: bold;
      color: #929293;

      .rating {
        display: flex;
        margin-top: 8px;
        img {
          width: 24px;
          height: 24px;
          margin-right: 8px;
        }
      }
    }
  }
  .comment {
    flex: 2;
    padding-right: 16px;
  }
}

.error-border {
  border: 1px red solid !important;
}

ul.timeline {
  list-style-type: none;
  position: relative;
}

.bar {
  background: #56c378;
  display: inline-block;
  position: absolute;
  left: 6px;
  bottom: 0px;
  width: 2px;
  height: 100%;
  &.cancel{
    background:#ff434f;
  }
  &.pending{
    background:#e5e7eb
  }
}

ul.timeline {
  li {
    position: relative;
    padding-bottom: 10px;
    min-height: 45px;
    padding-left: 25px;
    &.cancel:before {
      content: "\f00d";
      color: #ff434f;
      border-color: #ff434f;
    }
    &.pending:before {
      color: #e5e7eb;
      border-color: #e5e7eb;
    }
    &:last-child {
      padding-bottom: 0;
    }
  }
  & li:before {
    text-align: center;
    font-family: "Font Awesome 5 Free";
    content: "\f00c";
    font-weight: 600;
    background: white;
    display: inline-block;
    position: absolute;
    border-radius: 50%;
    color: #56c378;
    border: 2px solid #56c378;
    left: -2px;
    /* bottom: 0; */
    width: 20px;
    height: 20px;
    z-index: 1;
  }
}
</style>
